// extracted by mini-css-extract-plugin
export var careerSummary = "career-summary-module--careerSummary--4fb9a";